<template>
    <div class="content content-fixed content-auth-alt">
      <div class="container ht-100p">
        <div class="ht-100p d-flex flex-column align-items-center justify-content-center">
          <div class="wd-150 wd-sm-250 mg-b-30"><img src="https://res.gosmart.mn/static/df/assets/img/img16.png" class="img-fluid" alt=""></div>
          <h4 v-if="rdy==true" class="tx-20 tx-sm-24">QR кодыг амжилттай уншлаа</h4>
          <h4 v-else class="tx-20 tx-sm-24">Түр хүлээнэ үү...</h4>
          <p v-if="rdy==true" class="tx-color-03 mg-b-40">Таныг {{courseName}}-н <br />{{lessonName}} хичээлийн танхимын ирцэд <br />амжилттай бүртгүүллээ</p>
          <div v-if="rdy==true && ldng==false" class="tx-13 tx-lg-14 mg-b-40">
            <a href="/" class="btn btn-brand-02 d-inline-flex align-items-center">Эхлэл хуудасруу очих</a>
            <!-- <a href="" class="btn btn-white d-inline-flex align-items-center mg-l-5">Contact Support</a> -->
          </div>
          <!-- <span class="tx-12 tx-color-03">Mailbox with envelope vector is created by <a href="https://www.freepik.com/free-photos-vectors/background">freepik (freepik.com)</a></span> -->
        </div>
      </div><!-- container -->
    </div>
</template>
<script>
import { request } from "@/api/all";

export default {
    data(){
      return{
        rdy: false,
        courseName: null,
        lessonName: null,
        ldng: false,
      }
    },
    mounted(){
        this.attendeeee();
    },
    methods:{
        toggleBodyClass(addRemoveClass, className){
            const el = document.body;
            if (addRemoveClass === "addClass") { el.classList.add(className); } 
            else { el.classList.remove(className); }
        },

        attendeeee(){
          this.toggleBodyClass("addClass", "dynamic-locker");
          this.ldng= true;
          request({
            api: { method: "POST", url: "v2/learn/LessonFinish" },
            params: { 
                courseId: this.$route.params.cid, 
                lessonId: this.$route.params.lid, 
                isMobile: false,
                isQr: true
            },
            store: this.$store,
            }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            this.ldng= false;
            if (res != false) {
                this.courseName= res.data.courseName;
                this.lessonName= res.data.lessonName;

                this.rdy= true;
                //console.log('res', res);
            }
          });
        },
    }
};
</script>